"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IWorkoutFilter = void 0;
var IWorkoutFilter;
(function (IWorkoutFilter) {
    IWorkoutFilter["IsManual"] = "IsManual";
    IWorkoutFilter["IsMap"] = "IsMap";
    IWorkoutFilter["IsVault"] = "IsVault";
    IWorkoutFilter["IsVideo"] = "IsVideo";
    IWorkoutFilter["IsVue"] = "IsVue";
    IWorkoutFilter["PortraitOrientation"] = "PortraitOrientation";
})(IWorkoutFilter || (exports.IWorkoutFilter = IWorkoutFilter = {}));
//# sourceMappingURL=workout-filter.js.map